export class WishlistItemCard extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  static get requiredElements () {
    return ['media']
  }

  connectedCallback () {
    super.connectedCallback()

    this.touchX = null
    this.previousSwipeDirection = null
    this.currentSwipeDirection = null
    this.currentIndex = 0

    this.register()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this, 'touchstart', this.handleTouchStart.bind(this))
    this.listeners.add(this, 'touchmove', this.handleTouchMove.bind(this))
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.unregister()
  }

  register () {
    this.tastemakersManager?.register(this)
  }

  unregister () {
    this.tastemakersManager?.unregister(this)
  }

  handleTouchStart (event) {
    this.touchX = event.touches?.[0]?.clientX
    this.els?.media?.element?.setAttribute('data-touched', 'true')
  }

  handleTouchMove (event) {
    const clientX = event.touches?.[0]?.clientX

    this.previousSwipeDirection = this.currentSwipeDirection

    if (this.touchX && this.touchX !== clientX) {
      // Left swipe
      if (clientX < this.touchX) {
        this.currentSwipeDirection = 'left'
      }

      // Right swipe
      if (clientX > this.touchX) {
        this.currentSwipeDirection = 'right'
      }
    }

    if (this.currentSwipeDirection !== this.previousSwipeDirection) {
      this.updateIndex()
    }

    this.touchX = clientX
  }

  updateIndex () {
    if (this.currentSwipeDirection === 'left') {
      this.currentIndex = 1
    } else {
      this.currentIndex = 0
    }
  }

  set currentIndex (index) {
    this._currentIndex = index
    this.els?.media?.element?.setAttribute('data-index', String(index))
  }

  get currentIndex () {
    return this._currentIndex
  }

  get tastemakersManager () {
    return window.BAO?.Tastemakers?.manager
  }
}

if (!customElements.get('wishlist-item-card')) {
  customElements.define('wishlist-item-card', WishlistItemCard, {
    extends: 'article',
  })
}
